module.exports = __webpack_public_path__ + "img/ubbbrrru.51c3c63d.svg";